import React, { Suspense } from 'react'
import ProgressIndicator from '@veneer/core/dist/esm/scripts/progress_indicator'

export const SuspenseWrapper = ({ children }) => {
  return (
    <Suspense
      fallback={
        <ProgressIndicator behavior={'indeterminate'} appearance="linear" />
      }
    >
      {children}
    </Suspense>
  )
}
